module.exports = "/app/themes/roboyo2021/dist/img/clock-bk.png?1503be5a32868af984a8fb02ab329349";